import { createAction, createListenerMiddleware } from '@reduxjs/toolkit';

import { fetchViewerDataThunk } from '@/entities/viewer';

export const initAppData = createAction('app/initData/pending');
export const initAppDataFulfilled = createAction('app/initData/fulfilled');
export const initAppDataRejected = createAction('app/initData/rejected');

export const initAppDataListener = createListenerMiddleware();

const startInitAppDataListener =
    initAppDataListener.startListening as TypedListening;

startInitAppDataListener({
    actionCreator: initAppData,
    effect: async (_, { dispatch }) => {
        try {
            const thunkAction = fetchViewerDataThunk();
            const resultAction = await dispatch(thunkAction);

            if (resultAction.type.endsWith('fulfilled')) {
                dispatch(initAppDataFulfilled());
            } else {
                dispatch(initAppDataRejected());
            }
        } catch (e) {
            dispatch(initAppDataRejected());
        }
    },
});
